import './accounts.css';
import { useRef, type ReactNode } from 'react';
import { Dialog } from '../../components/Dialog';
import { useToast } from '../../lib/toast';

// Zeigt einen Einmal-Link zum Weitergeben, wenn kein E-Mail-Versand eingerichtet ist (Einladung, Passwort).
export function LinkDialog({ link, title, text, onClose }: { link: string | null; title: string; text: ReactNode; onClose(): void }) {
  const toast = useToast();
  const input = useRef<HTMLInputElement>(null);

  async function copy() {
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      // Ohne Zugriff auf die Zwischenablage: Text markieren und klassisch kopieren
      input.current?.select();
      document.execCommand('copy');
    }
    toast('Link kopiert');
  }

  return (
    <Dialog open={!!link} onClose={onClose} title={title}>
      <p className="muted" style={{ margin: 0 }}>
        {text}
      </p>
      <div className="linkbox">
        <input
          ref={input}
          readOnly
          value={link ?? ''}
          aria-label="Link"
          onFocus={(e) => e.currentTarget.select()}
        />
        <button type="button" className="btn primary" onClick={() => void copy()}>
          Link kopieren
        </button>
      </div>
      <div className="dlg-actions">
        <button type="button" className="btn" onClick={onClose}>
          Fertig
        </button>
      </div>
    </Dialog>
  );
}
